import { INSPECTION_CHECKLIST_STEPS } from "../inspection-form.catalog";
import type { InspectionChecklistStepWrapperProps } from "./checklistStep.props";
import InspectionChecklistStep from "./InspectionChecklistStep";

const InspectionReservoirStep = (props: InspectionChecklistStepWrapperProps) => (
  <InspectionChecklistStep step={INSPECTION_CHECKLIST_STEPS.reservoir} {...props} />
);

export default InspectionReservoirStep;
